import React from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';
import LoadingNavBar from '../../components/navbar/LoadingNavBar';
import Footer from '../../components/footer/Footer';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const PrivacyChoices = () => {
  const { t } = useTranslation();
  
  const colors = {
    background: "#ffffff",
    primary: "#102a43",
    secondary: "#39ace7",
    textPrimary: "#212529",
    textSecondary: "#495057",
  };

  return (
    <>
      <LoadingNavBar showLoginButton={true} />
      <Box
        sx={{
          background: colors.background,
          color: colors.textPrimary,
          minHeight: '100vh',
          py: 15,
          px: { xs: 3, md: 6 },
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: colors.primary, textAlign: 'center' }}>
            {t(StringKeys.PRIVACY_CHOICES_TITLE)}
          </Typography>
          <Typography variant="subtitle1" gutterBottom sx={{ textAlign: 'center', color: colors.textSecondary }}>
            {t(StringKeys.PRIVACY_CHOICES_LAST_UPDATED)}
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Section 1 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.PRIVACY_CHOICES_ACCESS_INFO_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>a. {t('reviewing_your_information')}</strong>
            <br />
            {t(StringKeys.PRIVACY_CHOICES_ACCESS_INFO_CONTENT)}
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>b. {t('updating_your_information')}</strong>
            <br />
            {t(StringKeys.PRIVACY_CHOICES_UPDATE_INFO_CONTENT)}
          </Typography>

          {/* Section 2 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.PRIVACY_CHOICES_DELETE_ACCOUNT_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>a. {t('right_to_deletion')}</strong>
            <br />
            {t(StringKeys.PRIVACY_CHOICES_DELETE_ACCOUNT_CONTENT)}
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>b. {t('how_to_delete')}</strong>
            <br />
            {t(StringKeys.PRIVACY_CHOICES_DELETE_PROCESS_CONTENT)}
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>c. {t('data_retention')}</strong>
            <br />
            {t(StringKeys.PRIVACY_CHOICES_DATA_RETENTION_CONTENT)}
          </Typography>

          {/* Section 3 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.PRIVACY_CHOICES_COMMUNICATIONS_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>a. {t('marketing_communications')}</strong>
            <br />
            {t(StringKeys.PRIVACY_CHOICES_MARKETING_CONTENT)}
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>b. {t('transactional_communications')}</strong>
            <br />
            {t(StringKeys.PRIVACY_CHOICES_TRANSACTIONAL_CONTENT)}
          </Typography>

          {/* Section 4 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.PRIVACY_CHOICES_COOKIES_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.PRIVACY_CHOICES_COOKIES_CONTENT)}
          </Typography>

          {/* Section 5 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.PRIVACY_CHOICES_DATA_PORTABILITY_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.PRIVACY_CHOICES_DATA_PORTABILITY_CONTENT)}
          </Typography>

          {/* Section 6 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.PRIVACY_CHOICES_PROCESSING_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.PRIVACY_CHOICES_PROCESSING_CONTENT)}
          </Typography>

          {/* Section 7 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.PRIVACY_CHOICES_CONSENT_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.PRIVACY_CHOICES_CONSENT_CONTENT)}
          </Typography>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default PrivacyChoices;
